import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../components/breadCrumb";
import CheckBox from "../components/common/CheckBox";
import ComboBoxData from "../components/common/ComboBoxData";
import ComboBoxDataMulti from "../components/common/ComboBoxDataMulti";
import { NumericBox } from "../components/common/NumericBox";
import PageContent from "../components/pageContent";
import ProductBreadCrumb from "../components/products/ProductBreadCrumb";
import TopBarWithBreadCrumb from "../components/TopBarWithBreadCrumb";
import { apiGetAllBasesByProduct } from "../services/BasesService";
import { apiGetAllColorsForSampleCard } from "../services/ColorsService";
import { apiGetAllProducts } from "../services/ProductsService";
import { apiGetSampleCardsForProduct } from "../services/SampleCardsService";
import { MultiSelect } from "react-multi-select-component";

import './ExportRecepturPage.css';
import { useTranslation } from "react-i18next";
import { apiGetDiscounts } from "../services/DiscountsService";
import { apiGetAllPackagesByProduct } from "../services/PackagesService";
import { apiGetPriceList, apiGetPriceListCsv } from "../services/PriceListService";
import DataGrid from "../components/common/DataGrid";
import Spinner from "../components/common/Spinner";

interface Props {
    contextLevel: string;

}

const CenikPage = (props: Props) => {

    let initFormDataState: any =
    {
        'entireSampleCard': false,
        sampleCardId: null,
        colorIds: [],
        targetProductId: null,
        discountDisabled: false,
        allPackages: true,
        packageId: null
    };
    const [formData, setFormData] = useState(initFormDataState);
    const [packagesForProduct, setPackagesForProduct] = useState([]);
    let initSampleCards: any[] = [];
    const [sampleCardsForProduct, setSampleCardsForProduct] = useState(initSampleCards);
    const productInfo = useSelector((state: any) => state.productInfo);
    const dispatch = useDispatch();
    let initDiscounts: any[] = [];
    let initSelectedDiscount: any = null;
    let initSelectedPackage: any = null;
    const [loading, setLoading] = useState(false);
    const [discounts, setDiscounts] = useState(initDiscounts);
    const [selectedDiscount, setSelectedDiscount] = useState(initSelectedDiscount);
    const [selectedPackage, setSelectedPackage] = useState(initSelectedPackage);

    const [weightWithPigmentsIncluded, setWeightWithPigmentsIncluded] = useState(false);
    const [weightWithHardernerIncluded, setWeightWithHardernerIncluded] = useState(false);
    const [useCustomWeight, setUseCustomWeight] = useState(false);
    const [customWeight, setCustomWeight] = useState(0);

    const translationPrefix = 'PriceList';
    const [rows, setRows] = useState([]);
    const { t } = useTranslation(undefined, { keyPrefix: translationPrefix });

    useEffect(() => {

    }, []);

    useEffect(() => {

        loadData(productInfo.productId);
        loadDiscounts();
    }, [productInfo]);

    const loadDiscounts = async () => {

        let loadedDiscounts = await ensureDiscounts();
        setDiscounts(loadedDiscounts);
    };

    const loadData = async (productId) => {


        let sampleCards = await loadSampleCards(productId);
        let packages = await loadPackagesForProduct(productId);

        if (sampleCards && sampleCards.length > 0) {
            setFormData({
                ...formData, sampleCardId: sampleCards[0].id,
                packageId: (packages && packages.length > 0) ? packages[0].id : 0
            });
        }
    }

    const ensureDiscounts = async () => {

        //if (!discounts || discounts.length <= 0) {
        var loadedDiscountsResponse = await apiGetDiscounts();

        if (loadedDiscountsResponse.status == 200) {
            //setDiscounts(loadedDiscountsResponse.data.sort((a, b) => a.name.localeCompare(b.name)));
            setDiscounts(loadedDiscountsResponse.data);

            if (loadedDiscountsResponse.data.length > 0) {
                setSelectedDiscount(loadedDiscountsResponse.data[0]);
            }

            return loadedDiscountsResponse.data;
        }
        //  }

        return null;
    };

    const loadPackagesForProduct = async (productId) => {

        let packages = await apiGetAllPackagesByProduct(productId);

        setPackagesForProduct(packages.data);

        return packages.data;
    }

    const loadSampleCards = async (productId) => {

        let sampleCards = await apiGetSampleCardsForProduct(productId, false);

        setSampleCardsForProduct(sampleCards.data);
        return sampleCards.data;
    }
    const handleSampleCardChange = async (id) => {

        setFormData({ ...formData, sampleCardId: id });
    }

    const handlePackageChange = async (packageId: number) => {

        setFormData({ ...formData, packageId: packageId });

    };

    const handleDiscountChange = async (discountId: number) => {

        let currentDiscount = discounts.filter((a: any) => a.id == discountId)[0];
        setSelectedDiscount(currentDiscount);
    };

    const primaryDiscount =
        discounts && discounts.length > 0
            ? discounts.filter((a) => a.isPrimary)
            : null;

    const handleReportCreation = async () => {

        setLoading(true);

        var priceList = await apiGetPriceList(
            productInfo.productId, formData.sampleCardId, formData.allPackages,
            formData.packageId || 0, !formData.discountDisabled, selectedDiscount?.id,
            weightWithPigmentsIncluded,
            weightWithHardernerIncluded,
            useCustomWeight ? customWeight : 0);

        setRows(priceList.data);

        setLoading(false);

    }

    return <>
        <PageContent>
            <>
                <ProductBreadCrumb selectionOfProductIsRequired={true} />
                <TopBarWithBreadCrumb
                    contextLevel={props.contextLevel}
                    pageLevel="Receptury"
                />

                {loading && <Spinner loadingText={"Loading ..."} />}

                <div className="row" style={{ padding: '20px' }}>
                    <div className="col-4">

                        <div className="row">
                            <label className="col-sm-3 col-form-label zvlabel">
                                {t('Product')}
                            </label>
                            <div className="col-sm-9" style={{ alignSelf: 'center', fontWeight: 500 }}>
                                <span>{productInfo.productName}</span>
                            </div>
                        </div>

                        <ComboBoxData
                            id="sampleCards"
                            label={t('SampleBook')}
                            dataTextField="name"
                            dataValueField="id"
                            value={formData.sampleCardId}
                            handleChange={handleSampleCardChange}
                            rows={sampleCardsForProduct}
                        />

                        <CheckBox
                            id="chkAllPackages"
                            label={t('AllPackages')}
                            paddingLeft={"10px"}
                            handleCheckedChange={(checked) => {
                                setFormData({ ...formData, allPackages: checked });
                            }}
                            defaultValue={formData.allPackages}
                        />

                        {!formData.allPackages &&
                            <ComboBoxData
                                id="packages"
                                label={t('Package')}
                                dataTextField="formattedAmmountWithBase"
                                dataValueField="id"
                                defaultValue={
                                    selectedPackage && selectedPackage?.id
                                }
                                rows={packagesForProduct}
                                handleChange={handlePackageChange}
                            />
                        }


                        <CheckBox
                            id="weightWithPigmentsIncluded"
                            // label={t('Fields.WeightWithPigmentsIncluded')}
                            label="Báze+Pigment"
                            paddingLeft={"10px"}
                            handleCheckedChange={(checked) => {

                                setWeightWithPigmentsIncluded(checked);
                                if (checked) setWeightWithHardernerIncluded(!checked);
                            }}
                            defaultValue={weightWithPigmentsIncluded}
                        />

                        <CheckBox
                            id="weightWithHardernerIncluded"
                            //label={t('Fields.WeightWithHardernerIncluded')}
                            label="Natužená směs"
                            paddingLeft={"10px"}
                            handleCheckedChange={(checked) => {

                                setWeightWithHardernerIncluded(checked);
                                if (checked) setWeightWithPigmentsIncluded(!checked);
                            }}
                            defaultValue={weightWithHardernerIncluded}
                        />


                        <CheckBox
                            id="chkApplyDiscount"
                            label={t('ApplyDiscount')}
                            paddingLeft={"10px"}
                            handleCheckedChange={(checked) => {
                                setFormData({ ...formData, discountDisabled: !checked });
                            }}
                            defaultValue={!formData.discountDisabled}
                        />

                        {!formData.discountDisabled &&
                            <ComboBoxData
                                id="discounts"
                                label={t('Discounts')}
                                dataTextField="name"
                                dataValueField="id"
                                defaultValue={selectedDiscount ||
                                    (primaryDiscount && primaryDiscount.length > 0
                                        ? primaryDiscount[0]
                                        : null)
                                }
                                rows={discounts}
                                handleChange={handleDiscountChange}
                            />
                        }

                        <div className="row" style={{ justifyContent: 'center' }}>
                            <div className="col-12" style={{ textAlign: 'center' }}>
                                <button
                                    style={{ width: '100%' }}
                                    onClick={() => {
                                        handleReportCreation();
                                    }}
                                    type="button"
                                    className="btn-sm btn-primary"
                                >
                                    {t('CreateReport')}
                                </button>
                            </div>
                        </div>
                        <div className="row" style={{ justifyContent: 'center' }}>
                            <div className="col-12" style={{ textAlign: 'center' }}>
                                <button
                                    style={{ width: '100%',display:"none" }}
                                    onClick={async () => {
                                        //

                                        await apiGetPriceListCsv(productInfo.productId, formData.sampleCardId, formData.allPackages,
                                            formData.packageId || 0, false, selectedDiscount.id || 0,
                                            weightWithPigmentsIncluded, weightWithHardernerIncluded,
                                            useCustomWeight ? customWeight : 0).then((response) => {
                                                const href = URL.createObjectURL(response.data);

                                                // create "a" HTML element with href to file & click
                                                const link = document.createElement('a');
                                                link.href = href;
                                                link.setAttribute('download', t('ExportFilename')); //or any other extension
                                                document.body.appendChild(link);
                                                link.click();

                                                // clean up "a" element & remove ObjectURL
                                                document.body.removeChild(link);
                                                URL.revokeObjectURL(href);
                                            });
                                    }}
                                    type="button"
                                    className="btn-sm btn-primary"
                                >
                                    {t('ExportToCSV')}
                                </button>
                            </div>

                        </div>
                    </div>

                    <div className="col-8">
                        {!loading && rows && rows.length > 0 &&
                            <DataGrid
                                loading={loading}
                                rows={rows}
                                showDeleteButton={false}
                                showEditButton={false}
                                onDeleteRow={false}
                                cols={[
                                    {
                                        name: t('Fields.Package'),
                                        dataField: "package",
                                        isLinkToItem: false,
                                        sortable: true,
                                        filterable: false,
                                        filterType: "text",
                                    },
                                    {
                                        name: t('Fields.Base'),
                                        dataField: "basis",
                                        sortable: true,
                                        filterable: false,
                                        filterType: "text",
                                    },
                                    {
                                        name: t('Fields.Color'),
                                        dataField: "color",
                                        sortable: true,
                                        filterable: false,
                                        filterType: "text",
                                        fieldType: "numeric"
                                    }, {
                                        name: t('Fields.Version'),
                                        dataField: "version",
                                        sortable: true,
                                        filterable: false,
                                        filterType: "text",
                                        fieldType: "numeric"
                                    },
                                    {
                                        name: t('Fields.PackagePrice'),
                                        dataField: "packagePrice",
                                        sortable: true,
                                        filterable: false,
                                        filterType: "text",
                                        fieldType: "text"
                                    },
                                    {
                                        name: t('Fields.PigmentsPrice'),
                                        dataField: "pigmentsPrice",
                                        sortable: true,
                                        filterable: false,
                                        filterType: "text",
                                        fieldType: "text"
                                    }, {
                                        name: 'Cena Tužidel',
                                        dataField: "hardenersPrice",
                                        sortable: true,
                                        filterable: false,
                                        filterType: "text",
                                        fieldType: "text"
                                    },
                                    {
                                        name: t('Fields.TotalPrice'),
                                        dataField: "totalPrice",
                                        sortable: true,
                                        filterable: false,
                                        filterType: "text",
                                        fieldType: "text"
                                    }
                                ]}
                            />
                        }
                    </div>
                </div>
            </>
        </PageContent >
    </>
}

export default CenikPage;